/**
 * ユーザー関連の型定義
 */
/**
 * ロール文字列を正規化（小文字に変換）
 *
 * 外部APIのレスポンス（Admin）を内部形式（admin）に変換
 *
 * @param role ロール文字列
 * @returns 小文字のRole型
 */
export function normalizeRole(role) {
    return role.toLowerCase();
}
//# sourceMappingURL=user.js.map